import React, { Fragment } from "react";
import { Box, Text } from "../../assets/ui";
import Theme from "../../assets/ui/theme";
import { TriangleIcon } from "../../assets/icons";
import Slider from "react-slick/lib";
import {
  FeatureType,
  ImacWrapper,
  IphoneWrapper,
  OptionsList,
  SectionTitle,
  SectionContent,
  SlideImage,
  StyledOption,
  TitleWrapper,
  StyledSectionWrapper,
  SliderWrapper,
  StyledIndicatorWrapper,
  StyledIndicator
} from "./ui";
import IphoneSlider from "../../components/SwipeSlider/iphonSlider";

const sliderData = [
  {
    img: "Section 3- 1PC.png",
    imgMobile: "Section 3- 1MOBILE.png",
    type: "Realtime Management ",
    title: "Real-time Management",
    description: "Connect in real-time to your bookings and customers"
  },
  {
    img: "Section 3- 2PC.png",
    imgMobile: "Section 3- 2MOBILE.png",
    type: "Calendar & Pricing",
    title: "Calendar and pricing",
    description:
      "Interactive AI calendar, choose your booking settings, set custom prices for different time periods and  sports. Set long periods with advance calendar"
  },
  {
    img: "Section 3- 3PC.png",
    imgMobile: "Section 3- 3MOBILE.png",
    type: "Booking App",
    title: "Booking App",
    description:
      "Using the Exsportia management system automatically creates your custom free booking app. Your sports and service now achievable at the click of a buttom."
  },
  {
    img: "Section 3- 4PC.png",
    imgMobile: "Section 3- 4MOBILE.png",
    type: "Members & subscriptions",
    title: "Members & subscriptions",
    description:
      "Create and add your memberships, sell directly from the app. Exsportia booking app will recognise who your members are when they book and provide them with there benefits. "
  },
  {
    img: "Section 3- 5PC.png",
    imgMobile: "Section 3- 5MOBILE.png",
    type: "Statements and Accounts",
    title: "Statements & Accounts",
    description:
      "See exactly how much you earn, autmatic accounts mean you can just print off your monthly statements."
  },
  {
    img: "Section 3- 6PC.png",
    imgMobile: "Section 3- 6MOBILE.png",
    type: "Exsportia Live",
    title: "Exsportia Live",
    description:
      "Going live on the network adds your facility to the instant book. Anyone can now see your calendars and prices and book directly from Exsportia.com"
  },
  {
    img: "Section 3- 4PC.png",
    imgMobile: "Section 3- 4MOBILE.png",
    type: "24/7 Support",
    title: "24/7 Support",
    description:
      "Speak to a human 24/7 , our VMS client support will be on hand instantly to help with anything whether its to add your sports or how to cancel a booking. "
  }
];

class FeaturesDemoList extends React.Component {
  state = {
    currentSlide: 0,
    nav1: null,
    nav2: null,
    oldIndex: 0,
    autoplay: true
  };

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
  }

  stopAutoplay = () => {
    this.setState({ autoplay: false });
  };

  onUserSelectOption = index => {
    this.slider1.slickGoTo(index);
    this.stopAutoplay();
  };

  render() {
    const { currentSlide, oldIndex } = this.state;

    const settings1 = {
      dots: true,
      focusOnSelect: false,
      arrows: false,
      autoplay: this.state.autoplay,
      onSwipe: this.stopAutoplay,
      autoplaySpeed: 3000,
      speed: 500,
      slidesToShow: 1,
      infinite: true,
      beforeChange: (oldIndex, newIndex) => {
        this.setState({ currentSlide: newIndex, oldIndex });
      },

      appendDots: dots => {
        return (
          <StyledIndicatorWrapper bottom={["-10%", "-85%"]}>
            {dots}
          </StyledIndicatorWrapper>
        );
      },
      customPaging: i => {
        return (
          <div>
            <StyledIndicator></StyledIndicator>
          </div>
        );
      },

      responsive: [
        {
          breakpoint: 831,
          settings: {
            slidesPerRow: 1,
            rows: 1,
            slidesToShow: 1
          }
        },
        {
          breakpoint: 5000,
          settings: {
            dots: false
          }
        }
      ]
    };

    const settings2 = {
      dots: false,
      focusOnSelect: false,
      arrows: false,
      autoplay: false,
      speed: 500,
      slidesToShow: 1,
      infinite: true
    };
    return (
      <StyledSectionWrapper>
        <Box
          position="relative"
          minHeight={["210px", "180px", "180px", "210px"]}
        >
          {sliderData.map((el, index) => {
            return (
              <Fragment key={index}>
                <TitleWrapper
                  isActive={index === currentSlide}
                  isOld={index === oldIndex && oldIndex !== currentSlide}
                >
                  <Fragment>
                    <SectionTitle
                      fontSize={["28px", null, null, "36px"]}
                      color={Theme.colors.white}
                      maxWidth={["100%", null, null, "850px"]}
                      marginBottom={["16px"]}
                    >
                      {el.title}
                    </SectionTitle>
                    <Text
                      fontSize={["16px", null, "24px"]}
                      lineHeight={["24px", null, "30px"]}
                      maxWidth={["100%", null, null, "850px"]}
                      fontWeight={300}
                      color="#A5B3C7"
                    >
                      {el.description}
                    </Text>
                  </Fragment>
                </TitleWrapper>
              </Fragment>
            );
          })}
        </Box>

        <SectionContent>
          <SliderWrapper>
            <ImacWrapper>
              <div className="mac-header"></div>
              <Box
                bg={"#010101"}
                borderRadius="2%"
                overflow="hidden"
                borderBottomRightRadius="4%"
                borderBottomLeftRadius="4%"
              >
                <Slider
                  asNavFor={this.state.nav2}
                  ref={slider => (this.slider1 = slider)}
                  {...settings1}
                >
                  {sliderData.map((el, index) => {
                    return (
                      <Box key={index}>
                        <SlideImage src={`./images/${el.img}`} alt={""} />
                      </Box>
                    );
                  })}
                </Slider>
              </Box>
            </ImacWrapper>
            <IphoneWrapper>
              <IphoneSlider
                asNavFor={this.state.nav1}
                settings={settings2}
                refSlider={slider => (this.slider2 = slider)}
                imageTitle={"imgMobile"}
                sliderContent={sliderData}
              />
            </IphoneWrapper>
            {sliderData.map((el, index) => {
              return (
                <Box key={index}>
                  {index === currentSlide ? (
                    <FeatureType
                      fontSize={"18px"}
                      lineHeight={"40px"}
                      fontWeight={700}
                      color={Theme.colors.mainGreen}
                      textAlign={"center"}
                    >
                      {el.type}
                    </FeatureType>
                  ) : null}
                </Box>
              );
            })}
          </SliderWrapper>

          <OptionsList>
            <Text
              color="#8697AE"
              fontSize="21px"
              lineHeight="36px"
              fontWeight="bold"
              margin="0 0 36px 0"
            >
              Core features:
            </Text>
            <Box borderLeft="1px solid #4d4d4d" padding={"0 0 0 30px"}>
              {sliderData.map((el, index) => {
                return (
                  <StyledOption
                    fontSize={"18px"}
                    lineHeight={"40px"}
                    fontWeight={700}
                    color={
                      currentSlide === index
                        ? Theme.colors.mainGreen
                        : Theme.colors.silverWhite
                    }
                    isCurrent={currentSlide === index}
                    marginBottom={["5px"]}
                    textAlign={"left"}
                    key={index}
                    onClick={() => this.onUserSelectOption(index)}
                  >
                    {el.type}
                    {currentSlide === index && <TriangleIcon />}
                  </StyledOption>
                );
              })}
            </Box>
          </OptionsList>
        </SectionContent>
      </StyledSectionWrapper>
    );
  }
}

export default FeaturesDemoList;
